import ApplicationError from './ApplicationError';
export default class BadResponseError extends ApplicationError {
    constructor(response) {
        super(`Get bad response when performing ${response.url} request: ${response.status}`);
        this.response = response;
        this.name = 'BadResponseError';
    }
}
